{
  "code": "Код",
  "codeExecute": "Выполнить код",
  "noTestCases": "Нет ни одного тест кейса чтобы запустить проверку",
  "retry": "Начать сначала",
  "submitCode": "Сдать код на проверку",
  "test": "Тест {{ value }}",
  "tooManyInputs": "Вы используете слишком много input(), в этой задаче их должно быть"
}
